<!-- create a template to use the imageviewer -->
<ng-template #itemTemplate let-index="index" let-type="type" let-data="data" let-currIndex="currIndex">
	<ng-container *ngIf="type === 'imageViewer' && index === currIndex" >
<!-- The ngx-imageviewer is commented out because it does not handle paths with no extensions. -->
<!-- <ngx-imageviewer [src]="data.src"></ngx-imageviewer> -->
    <img [src]="data.src">
  </ng-container>
</ng-template>